export const QALEA_ENS_CERTIFICATE_URL =
  'https://qalea-app-resources-hosting.s3.eu-west-1.amazonaws.com/static/docs/Certificado+ENS-2026_0057-2026-04-20.pdf'
export const QALEA_ENS_HIGH_LOGO_SRC = '/standards/ens-logo-high.png'
